<template>
  <span
    v-if="visible"
    class="collect-delay-days-chip"
    :title="label"
  >
    {{ label }}
  </span>
</template>

<script>
import { getDuration } from '@/assets/plugins/mps-common/time/duration-util'

export default {
  name: 'CollectDelayDaysChip',
  props: {
    datetime: {
      default: null,
    },
  },
  computed: {
    delayDays() {
      if (!this.datetime) return 0
      try {
        return Math.floor(getDuration(this.datetime).as('days'))
      } catch (e) {
        return 0
      }
    },
    visible() {
      return this.delayDays >= 1
    },
    label() {
      return `${this.$translate('수집 지연')} ${this.delayDays}${this.$translate('일')}`
    },
  },
}
</script>

<style scoped>
.collect-delay-days-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid #fb923c;
  background: #fff7ed;
  color: #9a3412;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
